












































import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { ActiveInject, ActiveProvide } from '@/support/reactive';
import JdsIcon from '@/design-system/icons/JdsIcon.vue';
import { Location } from 'vue-router';
import { Portal } from '@linusborg/vue-simple-portal';

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog 5.2.0 Support flyout
 * @changelog 6.2.3 adds inner overflow support
 * @changelog 6.9.0 Fixes tooltip positioning
 */
@Component({
    components: { JdsIcon, SimplePortal: Portal }
})
export default class JdsMeridianItem extends Vue {
    /**
     * Tooltip label
     */
    @Prop({ default: '' }) label!: string;
    /**
     * Can *not* be used with the flyout slot
     */
    @Prop({ default: '' }) to!: Location;
    /**
     * Accepts any JDS-Icon
     */
    @Prop({ default: '' }) icon!: string;

    /**
     * Will make the flyout match the height of the Meridian
     */
    @Prop({ default: false, type: Boolean }) tall!: boolean;

    @ActiveProvide('jds.meridian.context') provideContext = true;
    @ActiveInject({ from: 'jds.meridian.open', default: false }) wideParent!: boolean;
    @ActiveInject({ from: 'jds.meridian.uid', default: null }) meridianUid!: string | null;
    @ActiveInject({ from: 'jds.meridian.scrollTop', default: null }) meridianScrollTop!: number;

    @Ref() flyoutEl!: HTMLElement;
    @Ref() itemEl!: HTMLElement;

    public flyoutOpen = false;

    get tooltipStyles() {
        return {
            transform: `translateY(-${52 + this.meridianScrollTop}px)`,
        };
    }

    get flyoutStyles() {
        return {
            left: this.wideParent ? '256px' : '64px',
            ...(!this.tall && { height: 'max-content', maxHeight: '100%' }),
            ...(this.tall && { top: 0 }),
            bottom: 0,
            width: 'min(400px, 30vw)',
        };
    }

    beforeDestroy() {
        document.removeEventListener('click', this.handleFlyoutOutsideClick);
    }

    handleFlyoutItemClick(): void {
        if (!this.flyoutOpen) {
            this.openFlyout();
        } else {
            this.closeFlyout();
        }
    }

    handleFlyoutOutsideClick(e: MouseEvent): void {
        if (!this.flyoutEl?.contains(e.target as Node) && !this.itemEl?.contains(e.target as Node)) {
            this.closeFlyout();
        }
    }

    openFlyout() {
        this.flyoutOpen = true;
        this.$nextTick(() => {
            document.addEventListener('click', this.handleFlyoutOutsideClick);
        });
    }

    closeFlyout() {
        this.flyoutOpen = false;
        this.$nextTick(() => {
            document.removeEventListener('click', this.handleFlyoutOutsideClick);
        });
    }
}
